import React from 'react';
import { shape, string, func, oneOfType, number } from 'prop-types';
import BaseTile from 'components/tiles/BaseTile';
import ContentTile from 'components/tiles/ContentTile';

export default function ListingItem({ item, tileType, handleOpenModal, handleMouseEvent, refType }) {
    // Determine which tile component gets rendered
    switch (tileType) {
        case 'contentTable':
            return (
                <ContentTile
                    item={item}
                    handleOpenModal={handleOpenModal}
                    handleMouseEvent={handleMouseEvent}
                    refType={refType}
                />
            );
        default:
            return (
                <BaseTile item={item} />
            );
    }
}

ListingItem.propTypes = {
    item: shape({
        Docket_ID: oneOfType([string, number]),
        DocketDate: string.isRequired,
        JobID: oneOfType([string, number]).isRequired,
        SupplierTradingName: string,
        EquipmentName: string,
        MaterialType: string,
        SiteForemanName: string,
        SiteName: string,
        StatusName: string,
        DraftDocketNumber: oneOfType([string, number]).isRequired
    }).isRequired,
    tileType: string.isRequired,
    handleOpenModal: func.isRequired,
    handleMouseEvent: func,
    refType: string
};

ListingItem.defaultProps = {
    handleMouseEvent: () => {},
    refType: 'client'
};
